import React, { useState } from 'react';
import './Testimonials.css';
import test from '../../Assets/testimonials.png';
import ScrollToTopButton from '../../Components/ScrollTop/ScrollTopButton';
const Testimonials = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    
    const testimonials = [
        {
            text: "We’ve been working with MESLHA for over a year now, and their corporate services have been invaluable to our business. From opening our corporate bank account to handling all our tax and VAT filings, they make everything seamless. The team is highly professional, reliable, and always ready to assist with any challenges. We couldn’t ask for a better partner to help us navigate the complexities of doing business in the UAE.",
            author: "Ahmed R"
        },
        {
            text: "MESLHA helped us open our corporate bank account without any hassle. The team took care of all the documentation and guided us through the bank selection process, ensuring we got the best solutions for our needs. Their attention to detail and customer-first approach has made a significant difference in our business operations. I highly recommend their services to anyone looking for professional and efficient corporate support in the UAE",
            author: "Maria Lucifer"
        },
        {
            text: "As a growing business in the UAE, managing tax compliance and bookkeeping is critical. MESLHA’s accounting and VAT services have been a game-changer for us. They made the process of corporate tax registration and VAT filing straightforward and stress-free. The team is not only knowledgeable but also proactive, ensuring we stay ahead of all regulatory requirements. We’re confident in their expertise and are grateful for their continued support.",
            author: "David Paul"
        }
    ];

    const nextTestimonial = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    };

    const prevTestimonial = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
    };

    return (
        <div className="py-16 px-4 bg-gradient-to-b from-gray-100 to-white" id='blogs'>
            <div className="max-w-7xl mx-auto">
                <h2 className="tracking-wide text-black text-center font-bold text-4xl md:text-5xl mb-12">
                    Testimonials
                </h2>
                
                <div className="relative bg-white rounded-lg shadow-lg p-8 md:p-12 mx-auto max-w-4xl">
                    <div className="absolute top-0 left-0 w-full h-2 golden-accent rounded-t-lg"></div>
                    
                    <div className="flex justify-center mb-6">
                        <div className="w-16 h-16 golden-accent-light rounded-full flex items-center justify-center">
                            <img src={test} />
                        </div>
                    </div>
                    
                    <div className="text-center mb-8">
                        <p className="text-gray-700 text-lg md:text-xl italic mb-8">
                            "{testimonials[currentIndex].text}"
                        </p>
                        <div className="h-px w-24 bg-gray-300 mx-auto mb-4"></div>
                        <h4 className="font-semibold text-lg text-gray-900">{testimonials[currentIndex].author}</h4>
                        {testimonials[currentIndex].position && (
                            <p className="text-gray-600">{testimonials[currentIndex].position}</p>
                        )}
                    </div>
                    
                    <div className="flex justify-center items-center space-x-4">
                        <button 
                            onClick={prevTestimonial}
                            className="bg-gray-800 hover:bg-gray-900 text-white px-4 py-2 rounded-lg transition-colors flex items-center text-sm"
                        >
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
                            </svg>
                            Previous
                        </button>
                        <button 
                            onClick={nextTestimonial}
                            className="bg-gray-800 hover:bg-gray-900 text-white px-4 py-2 rounded-lg transition-colors flex items-center text-sm"
                        >
                            Next
                            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                            </svg>
                        </button>
                    </div>
                    
                    <div className="flex justify-center mt-6">
                        {testimonials.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentIndex(index)}
                                className={`w-3 h-3 mx-1 rounded-full transition-all ${
                                    currentIndex === index ? 'bg-blue-600 scale-125' : 'bg-gray-300 hover:bg-gray-400'
                                }`}
                                aria-label={`Go to testimonial ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>

                <ScrollToTopButton />
            </div>
        </div>
    );
};

export default Testimonials;